import type { BlueprintBackgroundColorModifier } from '@/grove-blueprints/generated-types'

const BACKGROUND_COLOR_CLASS: Record<
  BlueprintBackgroundColorModifier['token'],
  string
> = {
  primaryGreen: 'bg-acorns-green',
  primaryPurple: 'bg-acorns-purple',
  primaryForest: 'bg-acorns-forest',
  primarySunrise: 'bg-acorns-sunrise',
  primaryError: 'bg-error',
  primaryGoHenry: 'bg-acorns-go-henry',
  primarySky: 'bg-acorns-sky',
  primarySlate: 'bg-acorns-slate',
  primaryStone: 'bg-acorns-stone',
  primaryStoneLight: 'bg-acorns-stone-light',
  primaryIvory: 'bg-acorns-ivory',
  primaryIvoryLight: 'bg-acorns-ivory-light',
  primaryWhite: 'bg-white',
  naturalEcru: 'bg-acorns-ecru',
  naturalCloud: 'bg-acorns-cloud',
  naturalBeige: 'bg-acorns-beige',
  naturalSand: 'bg-acorns-sand',
  naturalBark: 'bg-acorns-bark',
  naturalMushroom: 'bg-acorns-mushroom',
  naturalAmber: 'bg-acorns-amber',
  naturalFern: 'bg-acorns-fern',
  naturalLightOak: 'bg-acorns-light-oak',
  naturalDarkOak: 'bg-acorns-dark-oak',
  naturalMoss: 'bg-acorns-moss',
  naturalDarkForest: 'bg-acorns-dark-forest',
  naturalEmerald: 'bg-acorns-emerald',
  naturalMidnightForest: 'bg-acorns-midnight-forest',
  naturalPlum: 'bg-acorns-plum',
  naturalDusk: 'bg-acorns-dusk',
  naturalCharcoal: 'bg-acorns-charcoal',
  naturalRosewood: 'bg-acorns-rosewood',
  naturalGold1: 'bg-acorns-gold-1',
  naturalGold2: 'bg-acorns-gold-2',
}

export function resolveBackgroundColorModifier(
  modifier: BlueprintBackgroundColorModifier,
): string {
  return BACKGROUND_COLOR_CLASS[modifier.token]
}
